<script>
import ManageAllocationFormRow from '../ManageAllocationFormRow/ManageAllocationFromRow.vue';
import ManageAllocationFormHeader from '../ManageAllocationFormHeader/ManageAllocationFormHeader.vue';
import ManageAllocationFormAccept from '../ManageAllocationFormAccept/ManageAllocationFormAccept.vue'
import {mapState, mapActions} from 'vuex';
import * as Validator from '../../services/ValidatorService';

export default {
    components: {
        ManageAllocationFormRow,
        ManageAllocationFormHeader,
        ManageAllocationFormAccept
    },
    computed: {
        ...mapState({
            rows: state => state.allocation.form.rows,
            loading: state => state.allocation.form.allocations.loading,
            error: state => state.allocation.form.allocations.error,
            noContent: state => state.allocation.allocations.noContent,
            accommodation: state => state.allocation.form.filters.selected.accommodation,
            selected: state => state.allocation.form.filters.selected,
            items: state => state.allocation.allocations.items,
            validator: state => state.allocation.form.validator,
            formOpen: state => state.allocation.form.open,
        }),
        formClasses() {
            return {
                "manage-allocation-form__heading--open": this.formOpen,
                "manage-allocation-form__heading--closed": !this.formOpen
            }
        }
    },
    methods: {
        ...mapActions({
            setRow: 'allocation/setRow',
            addRow: 'allocation/addRow',
            removeRow: 'allocation/removeRow',
            duplicateRow: 'allocation/duplicateRow',
            resetForm: 'allocation/resetForm',
            getAllocationList: 'allocation/getAllocationList',
            addAllocations: 'allocation/addAllocations',
            validateInputs: 'allocation/validateAddAllocationInputs',
            submit: 'allocation/submitForm',
            toggleForm: 'allocation/toggleAddAllocationForm',
        }),
        submitForm() {
            this.validateInputs();
            // If input fields are invalid then its not possible to submit
            if (!this.validator.error) {
                const accommodationSiteId = this.selected.accommodation.accommodationSiteId;
                let oldDates = [];
                const newDates = this.rows;
                if (accommodationSiteId) {
                    // If accommodation has allocations then fetch those or just an empty array.
                    oldDates = (this.items) ? this.items[accommodationSiteId] : [];
                }
                let overlapping = Validator.validateAddAllocationPeriod(newDates, oldDates);
                this.submit(overlapping);
            }
        }
    }
}
</script>
<template>
    <div class="manage-allocation-form">
        <manage-allocation-form-accept
            :label="'Adding allocations'"
            :method="'add'"
            @accept="addAllocations"/>
        <div :class="formClasses"
             class="manage-allocation-form__heading"
             @click="toggleForm">
            {{ $t('manageAllocationForm.heading') }}
        </div>
        <div v-if="formOpen"
             class="manage-allocatino-form__content">
            <div v-if="validator.error"
                 class="manage-allocation-form__error">
                <p v-for="message in validator.messages"
                   :key="message">{{ message }}</p>
            </div>
            <div class="manage-allocation-form__header">
                <manage-allocation-form-header/>
            </div>

            <div class="manage-allocation-form__body">
                <manage-allocation-form-row
                    v-for="(row, index) in rows"
                    :key="index"
                    :removable="rows.length > 1"
                    :row="row"
                    @update="setRow({data: $event, index})"
                    @add="addRow(index)"
                    @remove="removeRow(index)"
                    @duplicate="duplicateRow({data: $event, index})"/>
            </div>
            <div class="manage-allocation-form__controls">
                <div class="manage-allocation-form__control-buttons">
                    <button :disabled="loading"
                            class="manage-allocation-form__submit"
                            @click="submitForm">
                        {{ $t('manageAllocationForm.buttons.submit') }}
                    </button>
                    <button :disabled="loading"
                            class="manage-allocation-form__reset"
                            @click="resetForm">
                        {{ $t('manageAllocationForm.buttons.reset') }}
                    </button>
                </div>
                <div class="manage-allocation-form__control-message">
                    <span v-html="$t('manageAllocationForm.control-message.content')"/>
                    <strong>{{ selected.site.name }}</strong>
                    <span v-if="selected.accommodation">{{ $t('manageAllocationForm.control-message.on') }}</span>
                    <span><strong>{{ selected.accommodation.name }}</strong></span>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ManageAllocationForm/ManageAllocationForm.vue